module.exports = __webpack_public_path__ + "static/img/story09.6cf47cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/story/story09.jpg
// module id = 3LHp
// module chunks = 1